import Flatpickr from 'react-flatpickr';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line import/no-extraneous-dependencies
  require('flatpickr/dist/flatpickr.min.css');
}

export default Flatpickr;
